import wardrobePlanner from "./assets/wardrobe-planner.pdf";
import haldiImage from "./assets/haldi.webp";
import engagementImage from "./assets/engagement.webp";
import choodaImage from "./assets/chooda.webp";
import weddingImage from "./assets/wedding.webp";
import receptionImage from "./assets/reception.webp";
import coupleImage from "./assets/couple.webp";

export const weddingData = {
  couple: {
    bride: "Surbhi",
    groom: "Ashish",
    year: "2026",
    hashtag: "#AlwayS",
    family: "Kathuria & Mishra families, invite you to celebrate as they embark on a new journey together.",
    families: "Kathuria & Mishra",
  },

  venue: {
    name: "The Shahanshahi Adventure Park & Wellness Resort",
    city: "Dehradun",
    address: "Old Mussoorie Road, Dehradun, Uttarakhand",
    description: "Nestled between the lush hills of Mussoorie and the serene Dehradun Valley, our celebration unfolds at a luxurious hillside resort on the historic Old Mussoorie Road.",
    nearestAirport: "Jolly Grant Airport (DED)",
    website: "https://www.theshahanshahi.com/",
    mapUrl: "https://maps.google.com/?q=The+Shahanshahi+Adventure+Park+%26+Wellness+Resort+Dehradun",
    image: "https://www.theshahanshahi.com/webstatic/assets/img/about/frontimg.JPG",
    highlights: [
      "Beautifully manicured wedding lawn (500 guests)",
      "Indoor banquet hall & dining areas",
      "Swimming pool & wellness facilities",
      "Surrounded by Mussoorie hills",
    ],
  },

  stay: {
    checkIn: "21 November 2026",
    checkOut: "23 November 2026",
    note: "Accommodation is arranged at the venue itself. Details will be shared closer to the date.",
  },

  date: "21 & 22 November 2026",

  heroImage: "https://images.unsplash.com/photo-1538677859585-f8d2193ffa2b",

  coupleStory: "Started in the strangest way, we didn't see it coming,\nCaught in a shared whirlwind, hearts quietly becoming.\nOur lives aligned, though written differently,\nFrom north to south, drawn by a gentle destiny.\nAs if the world had paused and softly agreed,\nTo bring two stories together, just as meant to be.",

  coupleImage: coupleImage,

timeline: [
  {
    id: 1,
    title: "Haldi Carnival",
    date: "Nov 21",
    time: "11:00 AM",
    venue: "The Shahanshahi Resort",
    description: "We’re beginning the celebrations surrounded by sunshine, music and all our favourite people. As our families cover us in haldi and blessings, we hope you’ll join the fun, laugh with us and leave with a splash of yellow—and a memory we’ll carry long after the colours fade.",
    image: haldiImage,
    attire: "Light indo-western kurtas & dresses. Easy prints and shoes that can survive a pool party!",
  },
  {
    id: 2,
    title: "Engagement Soirée",
    date: "Nov 21",
    time: "7:00 PM",
    venue: "The Shahanshahi Resort",
    description: "Before the wedding day sweeps us along, we want to pause and share one beautiful evening with all of you. There will be rings, heartfelt words, music and dinner—but what we’ll remember most is looking around and seeing the people who shaped our lives gathered to celebrate the life we’re beginning together.",
    image: engagementImage,
    attire: "Evening gowns & dresses. Gentlemen in tuxedos.",
  },
  {
    id: 3,
    title: "Chooda Ceremony",
    date: "Nov 22",
    time: "9:00 AM",
    venue: "The Shahanshahi Resort",
    description: "This intimate morning holds a special place in our hearts. As Surbhi’s maternal family places the chooda on her wrists and sends her into a new chapter with their blessings, we would love for you to share in its quiet emotion—the laughter, the misty eyes and the warmth of two families standing close.",
    image: choodaImage,
    attire: "Traditional Indian wear. Bright colours welcome.",
  },
  {
    id: 4,
    title: "Wedding",
    date: "Nov 22",
    time: "2:00 PM",
    venue: "The Shahanshahi Resort",
    description: "This is the moment at the heart of it all. As we take our seven vows around the sacred fire, we’ll be promising to walk through every season of life together. Having you there as our witnesses will make those promises, and the beginning of our forever, even more meaningful.",
    image: weddingImage,
    attire: "Keep it desi — rich fabrics and Indian silhouettes.",
  },
  {
    id: 5,
    title: "Reception",
    date: "Nov 22",
    time: "7:00 PM",
    venue: "The Shahanshahi Resort",
     description: "With the vows made and the happy tears behind us, the evening is simply for celebrating. Come raise a glass, steal us for a photograph and meet us on the dance floor as we end our first day as a married couple surrounded by the people we love most.",
    image: receptionImage,
    attire: "Glamorous evening wear. Go all out!",
  }
  ],

  rsvp: {
    googleFormUrl: "https://forms.gle/e4s39YYCr5SfsWSf7",
    wardrobePlannerUrl: wardrobePlanner,
    registryUrl: "https://www.myregistry.com/giftlist/surbhiashish",
  },
};
